<form [formGroup]="form">
  <div class="row">
    <h3>Informe a experiência profissional de maior relevância.</h3>
  </div>
  <div class="row">
    <small>Você poderá adicionar as demais experiências através do seu
      perfil.</small>
  </div>

  <div class="row" style="margin-top: 20px">
    <mat-slide-toggle color="primary" formControlName="firstJob" (change)="onToggleChange()">Procurando meu primeiro
      emprego</mat-slide-toggle>
  </div>

  <div class="row" style="margin: 20px 0px">
    <mat-slide-toggle color="primary" formControlName="isPcd">Profissional com deficiência</mat-slide-toggle>
  </div>

  <div class="row" *ngIf="form.get('isPcd').value">
    <mat-form-field appearance="outline">
      <mat-label>Qual a sua deficiência</mat-label>
      <mat-select formControlName="pcdDescription" placeholder="Escolha uma deficiência">
        <mat-optgroup label="Amputação">
          <mat-option value="Amputação - Membros inferiores">Membros inferiores</mat-option>
          <mat-option value="Amputação - Membros superiores">Membros superiores</mat-option>
        </mat-optgroup>

        <mat-optgroup label="Auditiva">
          <mat-option value="Auditiva - Membros superiores">Surdez moderada</mat-option>
          <mat-option value="Auditiva - Surdez acentuada">Surdez acentuada</mat-option>
          <mat-option value="Auditiva - Surdez severa">Surdez severa</mat-option>
          <mat-option value="Auditiva - Surdez profunda">Surdez profunda</mat-option>
          <mat-option value="Auditiva - Anacusia">Anacusia</mat-option>
        </mat-optgroup>
        <mat-option>Autismo</mat-option>
        <mat-optgroup label="Física">
          <mat-option value="Física - Paraplegia">Paraplegia</mat-option>
          <mat-option value="Física - Paraparesia">Paraparesia</mat-option>
          <mat-option value="Física - Monoplegia">Monoplegia</mat-option>
          <mat-option value="Física - Monoparesia">Monoparesia</mat-option>
          <mat-option value="Física - Tetraplegia">Tetraplegia</mat-option>
          <mat-option value="Física - Tetraparesia">Tetraparesia</mat-option>
          <mat-option value="Física - Tripelgia">Tripelgia</mat-option>
          <mat-option value="Física - Triparesia">Triparesia</mat-option>
          <mat-option value="Física - Hemiplegia">Hemiplegia</mat-option>
          <mat-option value="Física - Hemiparesia">Hemiparesia</mat-option>
        </mat-optgroup>
        <mat-optgroup label="Intelectual">
          <mat-option value="Intelectual - Leve">Leve</mat-option>
          <mat-option value="Intelectual - Moderada">Moderada</mat-option>
          <mat-option value="Intelectual - Severa">Severa</mat-option>
        </mat-optgroup>
        <mat-optgroup label="Multipla">
          <mat-option value="Multipla - Física, sensorial e psíquica">Física, sensorial e psíquica</mat-option>
          <mat-option value="Multipla - Física e psíquica">Física e psíquica</mat-option>
          <mat-option value="Multipla - Física e sensorial">Física e sensorial</mat-option>
          <mat-option value="Multipla - Sensorial e psíquica">Sensorial e psíquica</mat-option>
        </mat-optgroup>
        <mat-optgroup label="Visual">
          <mat-option value="Visual - Baixa visão">Baixa visão</mat-option>
          <mat-option value="Visual - Moderada">Moderada</mat-option>
          <mat-option value="Visual - Profunda">Profunda</mat-option>
        </mat-optgroup>
        <mat-optgroup label="Cegueira">
          <mat-option value="Cegueira - Parcial">Parcial</mat-option>
          <mat-option value="Cegueira - Total">Total</mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>
  </div>
</form>

<mat-progress-bar mode="indeterminate" *ngIf="submiting"></mat-progress-bar>
<form [formGroup]="formVacancy" (submit)="addVacancy()" style="margin-top: 20px">
  <fieldset>
    <!-- <div class="row">
      <mat-list role="list" *ngIf="vacancies.length">
        <h3 matSubheader>Experiências</h3>
        <ng-container *ngFor="let vacancy of vacancies; let i = index">
          <mat-list-item>
            <h3 matLine>{{ vacancy.vacancy }} - {{ vacancy.company }}</h3>
            <p matLine>
              <span
                >de {{ vacancy.admissionDate | date : "dd/MM/yyyy" }} até
                {{ vacancy.departureDate | date : "dd/MM/yyyy" }}</span
              >
            </p>
            <button
              type="button"
              mat-icon-button
              color="warn"
              (click)="removeItem(i)"
            >
              <mat-icon>remove</mat-icon>
            </button>
          </mat-list-item>
        </ng-container>
      </mat-list>
    </div> -->

    <ng-container *ngIf="showForm">
      <legend>Experiência profissional</legend>
      <p>Sua experiencia pode ser qualquer modelo de contratação, clt, pj ou informal</p>

      <div class="row" style="margin-top: 20px">
        <mat-form-field appearance="outline">
          <mat-label>Empresa</mat-label>
          <input matInput type="text" placeholder="Nome da empresa" formControlName="company" />
          <mat-error *ngIf="formVacancy.get('company').errors?.required">Por favor informe o nome da empresa</mat-error>
        </mat-form-field>
      </div>

      <!-- <div class="row">
    
                <mat-form-field appearance="outline">
                    <mat-label>Setor</mat-label>                    
                    <input type="text"
                        id="vacancy"
                        (blur)="onBlurInput('vacancy')"
                        (focus)="onFocusInput('vacancy')"
                        placeholder="Informe seu setor"
                        matInput
                        formControlName="vacancy"
                        [matAutocomplete]="auto">
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let vacancy of filteredVacancies$ | async" [value]="vacancy.professional_name">
                            {{ vacancy.professional_name }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="formVacancy.get('vacancy').errors?.invalid">Escolha um dos valores que aparecem na lista ao digitar</mat-error>
                </mat-form-field>
    
            </div> -->

      <!-- <div class="row">
                <mat-form-field appearance="outline">
                    <mat-label>Área</mat-label>
                    <input type="text"
                        id="specializationName"
                        (blur)="onBlurInput('specializationName')"
                        (focus)="onFocusInput('specializationName')"
                        placeholder="Informe a cargo desejado"
                        matInput
                        formControlName="specializationName"
                        [matAutocomplete]="autoSpecializationName">
                    <mat-autocomplete #autoSpecializationName="matAutocomplete">
                        <mat-option *ngFor="let specializationName of filteredSpecializationName$ | async"
                            [value]="specializationName.specialization_name">
                            {{ specializationName.specialization_name }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="formVacancy.get('specializationName').errors?.invalid">Escolha um dos valores que aparecem na lista ao digitar</mat-error>
                </mat-form-field>
            </div> -->

      <!-- <div class="row">
                <mat-form-field appearance="outline">
                    <mat-label>Cargo</mat-label>
                    <input type="text"
                        id="roleLevel"
                        (blur)="onBlurInput('roleLevel')"
                        (focus)="onFocusInput('roleLevel')"
                        placeholder="Informe seu cargo"
                        matInput
                        formControlName="roleLevel"
                        [matAutocomplete]="autoRoleLevel">
                    <mat-autocomplete #autoRoleLevel="matAutocomplete">
                        <mat-option *ngFor="let roleLevel of filteredRoleLevel$ | async" [value]="roleLevel.role_level">
                            {{ roleLevel.role_level }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="formVacancy.get('roleLevel').errors?.invalid">Escolha um dos valores que aparecem na lista ao digitar</mat-error>
                </mat-form-field>
            </div> -->

      <!-- <div class="row">
                <mat-form-field appearance="outline">
                    <mat-label>Ramo de atividade</mat-label>
                    <input type="text"
                        id="branch"
                        (blur)="onBlurInput('branch')"
                        (focus)="onFocusInput('branch')"
                        placeholder="Informe seu ramo de atividade"
                        matInput
                        formControlName="branch"
                        [matAutocomplete]="autoBranch">
                    <mat-autocomplete #autoBranch="matAutocomplete">
                        <mat-option *ngFor="let branch of filteredBranch$| async" [value]="branch.branch">
                            {{ branch.branch }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="formVacancy.get('branch').errors?.invalid">Escolha um dos valores que aparecem na lista ao digitar</mat-error>
                </mat-form-field>
            </div> -->

      <!-- <div class="row">
                <mat-form-field appearance="outline">
                    <mat-label>Profissão</mat-label>
                    <input matInput placeholder="Informe a área de atuação" type="text" formControlName="office" />
                </mat-form-field>
            </div> -->

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Cargo</mat-label>
          <input type="text" id="Sinonimo" (blur)="onBlurInput('sinonimo')" (focus)="onFocusInput('sinonimo')"
            placeholder="Cargo" (keyup)="_filterSinonimo($event.target.value)" matInput formControlName="sinonimo"
            [matAutocomplete]="autoSinonimo" />
          <mat-autocomplete #autoSinonimo="matAutocomplete">
            <mat-option *ngFor="let Sinonimo of filteredSinonimo" [value]="Sinonimo.Name">
              {{ Sinonimo.Name }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="formVacancy.get('sinonimo').errors?.invalid">Escolha um dos valores que aparecem na lista ao
            digitar</mat-error>
          <mat-error *ngIf="formVacancy.get('sinonimo').errors?.required">Por favor informe o cargo</mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Descrição do seu trabalho</mat-label>
          <textarea matInput
            placeholder="lembre-se que é através da descrição que o recrutador vai selecionar os candidatos, preencha com a maior numero de informações sobre seu trabalho"
            formControlName="description" rows="10" maxlength="1000"></textarea>
          <mat-hint>Informe até 1000 caracteres</mat-hint>
          <mat-error *ngIf="formVacancy.get('description').errors?.required">Por favor informe uma descrição</mat-error>
          <mat-error *ngIf="formVacancy.get('description').errors?.maxlength">Por favor informe no máximo 1000
            caracteres</mat-error>
        </mat-form-field>
      </div>

      <div class="row" style="margin-top: 10px">
        <mat-label style="margin-left: 10px; margin-right: 5px">Regime de Contratação:</mat-label>
        <mat-radio-group formControlName="workregime">
          <mat-radio-button value="CLT" style="margin-right: 10px">
            CLT
          </mat-radio-button>
          <mat-radio-button value="PJ" style="margin-right: 10px">
            PJ
          </mat-radio-button>
          <mat-radio-button value="Informal"> Informal </mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="formVacancy.get('workregime').errors?.invalid">Escolha uma das opções</mat-error>
      </div>

      <div class="row" style="margin-top: 10px">
        <mat-form-field appearance="outline">
          <mat-label>Modelo de trabalho</mat-label>
          <mat-select placeholder="Selecione uma opção" formControlName="modalityjob">
            <mat-option value="Presencial">Presencial</mat-option>
            <mat-option value="Home Office">Home Office</mat-option>
            <mat-option value="Híbrido">Híbrido</mat-option>
          </mat-select>
          <mat-error *ngIf="formVacancy.get('modalityjob').errors?.invalid">Escolha uma das opções</mat-error>
          <mat-error *ngIf="formVacancy.get('modalityjob').errors?.required">Por favor selecione uma opção</mat-error>
        </mat-form-field>
      </div>

      <div class="row" style="margin-bottom: 20px; margin-top: 20px">
        <mat-slide-toggle color="primary" formControlName="currentJob">Estou atualmente nesse emprego</mat-slide-toggle>
      </div>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Data de admissão</mat-label>
          <input matInput type="text" inputmode="numeric" mask="00/0000" placeholder="MM/YYYY"
            formControlName="admissionDate" />
          <mat-error *ngIf="
              formVacancy.get('admissionDate').errors?.invalidDate === true
            ">Informe uma data valida</mat-error>
          <mat-error *ngIf="formVacancy.get('admissionDate').errors?.beforeDate === true">Data não pode ser maior que a
            data de admissão</mat-error>
        </mat-form-field>

        <ng-container *ngIf="formVacancy.get('currentJob').value === false">
          <mat-form-field appearance="outline">
            <mat-label>Data de saída</mat-label>
            <input matInput type="text" inputmode="numeric" mask="00/0000" placeholder="MM/YYYY"
              formControlName="departureDate" />
            <mat-error *ngIf="
                formVacancy.get('departureDate').errors?.departure === true
              ">Informe a data de saída desse emprego</mat-error>
            <mat-error *ngIf="
                formVacancy.get('departureDate').errors?.invalidDate === true
              ">Informe uma data valida</mat-error>
            <mat-error *ngIf="formVacancy.get('departureDate').errors?.maxDate === true">Data não pode ser maior que a
              atual</mat-error>
          </mat-form-field>
        </ng-container>
      </div>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Último salário</mat-label>
             <input matInput type="text" placeholder="Seu último salário" currencyMask inputmode="numeric"
              formControlName="salary"/>
        </mat-form-field>
      </div>
    </ng-container>

    <!-- <div class="actions" style="margin-bottom: 20px">
      <button
        mat-stroked-button
        type="button"
        color="primary"
        *ngIf="!showForm"
        (click)="showForm = true"
      >
        Adicionar cargo
      </button>
      <button mat-stroked-button type="submit" color="primary" *ngIf="showForm">
        Salvar cargo
      </button>
      <button
        mat-stroked-button
        type="button"
        color="warn"
        *ngIf="showForm"
        (click)="resetForm()"
      >
        Cancelar
      </button>
    </div> -->
  </fieldset>
</form>

<div class="actions right">
  <button
    mat-raised-button
    type="submit"
    color="primary"
    class="custom-primary"
    (click)="(formVacancy.valid || form.valid) && onSubmit(); addVacancy()"
    [disabled]="!formVacancy.valid && showForm"
    matStepperNext
  >
    Continuar
  </button>
  <button mat-raised-button color="primary" matStepperPrevious>Voltar</button>
</div>

<iframe *ngIf="mauticFormSrc" [src]="mauticFormSrc" hidden frameborder="0"></iframe>